import React from "react";
import { NicheMoreMenu } from "./NicheMoreMenu";
import { useNicheMoreMenu } from "./useNicheMoreMenu";
import { INicheMoreMenuContainerProps } from "@/common/buses/popups/popup-types";

export const NicheMoreMenuContainer: React.FC<INicheMoreMenuContainerProps> = ({
  niche,
  anchorEl
}) => {
  const { onClose, menuItems, } = useNicheMoreMenu({ niche });

  return (
    <NicheMoreMenu
      isOpen
      anchorEl={anchorEl}
      onClose={onClose}
      menuItems={menuItems}
    />
  );
};
